
import NavigationBar from "@/components/NavigationBar";
import { AdminDashboard } from "@/components/AdminDashboard";

const AdminPanel = () => {
  return (
    <div className="min-h-screen bg-gradient-background">
      <NavigationBar />
      <AdminDashboard />
    </div>
  );
};

export default AdminPanel;
